import React, { useState } from "react";
import { ChevronDownIcon } from "lucide-react";
type FaqItem = {
  question: string;
  answer: string;
};
type FaqAccordionProps = {
  items: FaqItem[];
};
export function FaqAccordion({
  items
}: FaqAccordionProps) {
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  return <div className="overflow-hidden rounded-[1.5rem] border border-[#e5def2] bg-white shadow-[0_12px_30px_rgba(23,42,74,0.06)]" data-id="element-1" data-mp="39s6moyeplarg">
      {items.map((item, index) => {
      const isOpen = openIndex === index;
      return <div key={item.question} className={index !== items.length - 1 ? "border-b border-[#eee9f5]" : ""} data-id="element-2" data-mp="3ijqjvg3p7ckb" data-mpi={index}>
            <h3 data-id="element-3" data-mp="1c4swqkceryo">
              <button type="button" className="flex w-full items-center justify-between gap-5 px-5 py-5 text-left text-base font-extrabold text-[#172A4A] transition-colors duration-200 hover:text-[#E93670] focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-inset focus-visible:ring-[#E93670] sm:px-7" aria-expanded={isOpen} onClick={() => setOpenIndex(isOpen ? null : index)} data-id="element-4" data-mp="1akau0f7t1hp">
                <span data-id="element-5" data-mp="3chqcklhntrfs">{item.question}</span>
                <ChevronDownIcon aria-hidden="true" className={`h-5 w-5 shrink-0 transition-transform duration-200 ${isOpen ? "rotate-180" : ""}`} data-id="element-6" data-mp="3ggz7htofrvcx" />
              </button>
            </h3>
            <div className={`grid overflow-hidden transition-[grid-template-rows] duration-200 ease-out ${isOpen ? "grid-rows-[1fr]" : "grid-rows-[0fr]"}`} data-id="element-7" data-mp="3q7aejp3f2ko1">
              <div className="min-h-0" data-id="element-8" data-mp="3v5vavdfjsk77">
                <p className="px-5 pb-6 text-sm leading-6 text-[#52617a] sm:px-7 sm:text-base" data-id="element-9" data-mp="402dv03fz1yc">{item.answer}</p>
              </div>
            </div>
          </div>;
    })}
    </div>;
}